// 其他信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default state => {
  const itemPics = get(state, 'currentShopBaseDetail.itemPics', [])
  return {
    title: i18n.gettext('菜单照片'),
    content: [
      {
        title: i18n.gettext('菜单照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: itemPics,
      },
    ],
  }
}
